/* -disable react/forbid-prop-types */
/* -disable react/require-default-props */
/* -disable jsx-a11y/anchor-is-valid */
// NPM imports

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';

// Project imports

import Button from '../../../../components/Button';
import RFTextField from '../../../../components/RFTextField';
import AlertMessage from '../../../../components/AlertMessage';
import { required, validEmail } from '../../../../utils/validators';

// Component imports

import './styles.css';

// Component

class LoginForm extends Component {
  _submit = formValues => {
    this.props.onSubmit(formValues);
  };

  render() {
    const { className, onForgotPassword, handleSubmit, invalid, ui } =
      this.props;

    return (
      <form
        className={`LoginForm ${className || ''}`}
        onSubmit={handleSubmit(this._submit)}
      >
        <Field
          name="email"
          validate={[required, validEmail]}
          floatingLabelText="E-mail"
          fullWidth
          props={{
            theme: 'light',
          }}
          component={RFTextField}
        />
        <Field
          name="password"
          validate={required}
          floatingLabelText="Senha"
          fullWidth
          props={{
            type: 'password',
            theme: 'light',
          }}
          component={RFTextField}
        />
        {ui.error && <AlertMessage error box message={ui.error} />}
        <div className="LoginForm__actions">
          <Button
            disabled={invalid || ui.isFetching}
            type="submit"
            className="LoginForm__button"
            text="Entrar"
            block
            outline
          />
          <a className="LoginForm__recover" onClick={onForgotPassword}>
            Esqueci minha senha
          </a>
        </div>
      </form>
    );
  }
}

LoginForm.propTypes = {
  ui: PropTypes.object,
  onSubmit: PropTypes.func,
  onForgotPassword: PropTypes.func,
};

// Redux

const mapStateToProps = () => ({
  initialValues: {
    email: '',
    password: '',
  },
});

export default connect(mapStateToProps)(
  reduxForm({ form: 'login' })(LoginForm),
);
